// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hy-6";
export var emphasizeQuantity = "_hy-3";
export var flatBottomCorners = "_hy-5";
export var productImage = "_hy-0";
export var quantityContainer = "_hy-2";
export var tooltip = "_hy-1";
export var wrapAndEllipsesOverflow = "_hy-4";